import http from './http';
import Vue from 'vue';
import { Toast } from 'wc-messagebox';
import { getLangAndCurrencyFromLocal,returnType } from '../utils';
import i18n from '../lang/index';
let pc_url = process.env.WEB_HOST

Vue.use(Toast);

function toast(msg, cb) {
  Vue.prototype.$toast(msg);
  typeof cb === 'function' && cb();
}

/** 取用户可读的提示文案:后端 msg 为空时不展示空白提示 */
function getAlertContent(msg) {
  return (msg === undefined || msg === null || String(msg).trim() === '')
    ? i18n.t('hotel.REQUEST_FAIL')
    : String(msg);
}


/** post请求 noHandleCode为true: 错误的code除了-1000， -1001 以外 不做全局处理  默认为 false*/
function post(mUrl, params, noHandleCode) {
  const hash = getLangAndCurrencyFromLocal();

  params = Object.assign({}, params, {currency_code: hash.currency_code, lan_type: hash.lan_type, language: hash.lan_type});
  return http.doPost(mUrl, params).then(resp => {
    if(Number(resp.code) !== 1 ){
      if (!noHandleCode || Number(resp.code) === -1000 || Number(resp.code) === -1001) {
        toast(getAlertContent(resp.msg), function(){
          if(Number(resp.code) === -1000 || Number(resp.code) === -1001){
            const curLocal = encodeURIComponent(window.location.href);

            window.location.href = `${pc_url}login.php?lan_type=${returnType(localStorage.getItem('lan_type'))}`;
          }
        });
        return false;
      }else {
        return resp;
      }
    }
    return resp;
  }).catch(err => {
    // 网络/HTTP异常:不能把 err.toString() 直接展示给用户
    toast(i18n.t('hotel.REQUEST_FAIL'));
  });
}

/**
 * get请求
 * noHandleCode为true或错误码数组时:除登录态失效(-1000/-1001)外不做全局toast,
 * 把完整resp交给调用方自行处理(如下单页的售罄/价格变动提示)
 */
function get(mUrl, params, noHandleCode) {
  const hash = getLangAndCurrencyFromLocal();

  params = Object.assign({}, params, {currency_code: hash.currency_code, lan_type: hash.lan_type, language: hash.lan_type});
  return http.doGet(mUrl, params).then(resp => {
    if(Number(resp.code) !== 1){
      if(Number(resp.code) === -1000 || Number(resp.code) === -1001){
        toast(getAlertContent(resp.msg), function (){
          const curLocal = encodeURIComponent(window.location.href);

          window.location.href = `${pc_url}login.php?lan_type=${returnType(localStorage.getItem('lan_type'))}`;
        });
        return false;
      }

      if(noHandleCode === true || (Array.isArray(noHandleCode) && noHandleCode.indexOf(Number(resp.code)) !== -1)){
        return resp;
      }

      toast(getAlertContent(resp.msg));
      return false;
    }
    return resp;
  }).catch(err => {
    // 网络/HTTP异常:不能把 err.toString() 直接展示给用户
    toast(i18n.t('hotel.REQUEST_FAIL'));
    return false;
  });
}

// 请求统一管理
export class Api{
  constructor(){};

  /** 检测用户登录状态 */
  checkUserLogin(params = {}){
    const url = 'User';
    return get(url, params);
  }

  /** 获取酒店筛选条件数据 */
  getHotelFilterConditions(params = {}){
    // const url = 'Hotel/SearchOptions';
    const url = 'Hotel/SearchOptionsV2';
    return get(url, params);
  }

  /** 获取酒店搜索列表数据 */
  getHotelList(params = {}, maxPrice){
    const url = 'Hotel';
    if(params.price_from == 0){
      delete params.price_from;
    }
    if(params.price_to == maxPrice){
      delete params.price_to
    }

    return get(url, params);
  }

  /** 获取酒店详情  (废弃) */
  getHotelDetail(params = {}){
    const url = `Hotel/${params.hotel_id}`;

    params = Object.assign({}, params, {lan_type: 1});
    delete params.hotel_id;
    return get(url, params);
  }

  /** 获取酒店基本信息 */
  getHotelBaseInfo(params = {}){
    const url = `HotelInfo/${params.hotel_id}`;

    params = Object.assign({}, params, {lan_type: 1});
    delete params.hotel_id;
    return get(url, params);
  }

  /** 获取酒店房型 */
  getHotelRooms(params = {}){
    // const url = `HotelPrice/${params.hotel_id}`;
    const url = `HotelPrice/searchBySupplier`;

    params = Object.assign({}, params, {lan_type: 1});
    // delete params.hotel_id;
    return post(url, params);
  }

  /**
   * 多供应商同步并发聚合获取酒店房型
   * 前端只需调用一次本接口, 后端并发请求各供应商并统一合并返回.
   */
  getHotelRoomsBySuppliers(params = {}){
    const url = `HotelPrice/searchBySuppliers`;

    params = Object.assign({}, params, {lan_type: 1});
    return post(url, params);
  }

  /** 酒店下单信息(售罄/价格变动类错误码透传给下单页,由页面弹框提示并返回详情页或按最新价继续) */
  prepareHotelOrder(params = {}){
    const url = `OrderPrepare/${params.order_type}`;

    delete params.order_type;
    delete params.hotel_id;
    return get(url, params, [30502, 30509, 30510, 30801, 30802, 31101]);
  }

  /** 获取酒店全部数据 */
  getHotelAllImages(params = {}){
    const url = 'Images';

    return get(url, params);
  }

  /** 获取酒店热门城市数据 */
  getHotRegion(params = {}){
    const url = 'RegionSearch';

    return get(url, params);
  }

  /** 地区或酒店搜索 */
  searchRegionOrHotel(params = {}){
    // const url = 'Place';
    const url = 'Place/V4';

    return get(url, params);
  }

  /** 酒店下单 noHandleCode为true: 业务错误码(如价格变动/售罄)由页面自行处理 */
  placingHotelOrder(params, noHandleCode){
    const url = 'HotelOrder';

    return post(url, params, noHandleCode);
  }

  /** 获取订单支付信息 */
  getPaymentInfo(params = {}){
    const url = `PayOrder/${params.orderId}`;

    return get(url);
  }

  /** 获取订单详情 */
  getOrderDetail(params = {}){
    const url = `OrderUnion/${params.orderId}`;

    return get(url);
  }

  /** 订单支付 */
  submitPayment(params = {}){
    const url = `PayOrder`;

    return post(url, params);
  }

  /** 酒店房型价格变动检测(30509价格变动/30510售罄由详情页弹框提示,其余全局提示) */
  checkHotelPriceChange(params = {}){
    const mUrl = 'PriceChecker';
    const hash = getLangAndCurrencyFromLocal();

    params = Object.assign({}, params, {currency_code: hash.currency_code, lan_type: hash.lan_type, language: hash.lan_type});
    return http.doPost(mUrl, params).then(resp => {
      // code为30509表示酒店价格有变动,30510表示已售罄
      if(Number(resp.code) !== 1 && Number(resp.code) !== 30509 && Number(resp.code) !== 30510){
        toast(getAlertContent(resp.msg), function(){
          if(Number(resp.code) === -1000 || Number(resp.code) === -1001){
            const curLocal = encodeURIComponent(window.location.href);

            window.location.href = `${pc_url}login.php?lan_type=${returnType(localStorage.getItem('lan_type'))}`;
          }
        });
        return false;
      }
      return resp;
    }).catch(err => {
      // 网络/HTTP异常:不能把 err.toString() 直接展示给用户
      toast(i18n.t('hotel.REQUEST_FAIL'));
    });
  }

  /** 获取酒店配置信息 */
  getBCCConfig(params = {}){
    const url = `HotelConfig`;

    return get(url, params);
  }

  /** 获取用户个人资产 */
  getUserWallet(params = {}){
    const url = `UserWallet`;

    return get(url, params);
  }

  /** 校验当前货币是否允许切换（当前货币有余额时不可切换） */
  checkChangeCurrency(params = {}){
    const url = `UserWallet/checkChangeCurrency`;

    return get(url, params);
  }

  /** BCC 直接下单 */
  bccPayment(params, noHandleCode){
    const url = `BCCBooking`;

    return post(url, params, noHandleCode);
  }

  /** 获取安全码 */
  getSecurityCode(params = {}){
    const url = 'SecretTradeKey';

    return post(url, params);
  }

  /** 获取用户所持优惠券列表 **/
  getHotelCoupon(params){
    const url = 'HotelCoupon';

    return get(url, params)
  }

  /** 绑定优惠券 **/
  bindCoupon(params, noHandleCode){
    const url = 'HotelCoupon';

    return post(url, params, noHandleCode)
  }

  /** 提交评价内容 */
  submitEvaluation(params = {}){
    const url = 'Hotel/Review';

    return post(url, params);
  }

  /** 获取酒店评价列表数据 */
  getEvaluationData(params = {}){
    const url = 'Hotel/Review';

    return get(url, params);
  }
}













// WEBPACK FOOTER //
// ./src/api/index.js